/* PB DRING SWEEP v2 engine (PB-1180, src M-4A99), for sections/pb-dring-sweep.liquid, part 1 "Hang anything".
   The scene is pinned with position:sticky on a tall track; everything is scrubbed by scroll (no timers), so scrolling
   back plays it in reverse. The art (snippets/pb-dring-sweep-art.liquid) is one SVG that fills its stage, so the D-ring
   scales with the section by itself; this script only swings the hanging things:
     4 things (keys, keychain, plush, cable), one scroll step each. Each swings in from the left and settles with a
     damped swing; at the next step it swings away to the right and fades as the next one swings in.
   Writes only SVG transform/opacity on the four groups and a class on the active list item; no page-level state.
   Reduced motion: not pinned, one static card per thing. Height-only resizes (iOS toolbar) are ignored. */
(function () {
  if (window.__pbdsBoot) { window.__pbdsBoot(); return; }
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var N = 4;

  function cl(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function eo(v) { v = cl(v); return 1 - Math.pow(1 - v, 3); }
  function ei(v) { v = cl(v); return v * v * v; }

  function boot(root) {
    if (root.__pbds) return;
    var track = root.querySelector('[data-track]'), box = root.querySelector('[data-scene-box]');
    var svg = root.querySelector('[data-stage]');
    if (!track || !box || !svg) return;
    root.__pbds = 1;
    var objs = [].slice.call(svg.querySelectorAll('[data-obj]'));
    if (RM) { staticCards(root, svg, objs); return; }

    root.classList.add('is-live');
    var labels = [].slice.call(root.querySelectorAll('[data-label]'));
    /* each thing is threaded through the slot: a back half under the plate ([data-objb]) and a front half over it
       ([data-obj]); both get the same transform so they swing as one */
    var O = objs.map(function (g) {
      var gb = svg.querySelector('[data-objb="' + g.getAttribute('data-obj') + '"]');
      return { g: g, gb: gb, px: g.getAttribute('data-px'), py: g.getAttribute('data-py'), a: null, o: null, vis: null };
    });
    var total = 1, vw = 0, vh = 0, near = false, raf = false, lastB = -1, on = -1;

    function measure() {
      vw = innerWidth; vh = innerHeight;
      total = Math.max(1, track.offsetHeight - box.offsetHeight);
      lastB = -1;
    }

    function frame() {
      raf = false;
      var r = track.getBoundingClientRect();
      var b = cl(-r.top / total) * N;           /* 0..4: thing i is on show from i to i+1 */
      if (Math.abs(b - lastB) < 0.0005) return;
      lastB = b;
      for (var i = 0; i < N; i++) {
        var o = O[i]; if (!o) continue;
        var a = 0, op = 1;
        /* in: swings in from the left from i - 0.25 (the first one is already hanging, it just settles) */
        var v = i === 0 ? (b + 0.35) / 0.9 : (b - (i - 0.25)) / 0.9;
        if (v <= 0) { op = 0; a = -42; }
        else if (v < 1) {
          a = -42 * Math.exp(-3.2 * v) * Math.cos(6.2832 * 1.25 * v) * (1 - v * 0.6);
          op = cl(v / 0.22);
        }
        /* out: at the next step it swings away to the right and fades */
        if (i < N - 1) {
          var u = (b - (i + 1 - 0.25)) / 0.32;
          if (u > 0) { a += 46 * ei(u); op *= 1 - eo(u); }
        }
        var vis = op > 0.01;
        if (vis !== o.vis) { o.vis = vis; o.g.style.display = vis ? '' : 'none'; if (o.gb) o.gb.style.display = vis ? '' : 'none'; }
        if (!vis) continue;
        var ar = Math.round(a * 10) / 10, orr = Math.round(op * 50) / 50;
        if (ar !== o.a) {
          o.a = ar; var tr = 'rotate(' + ar + ' ' + o.px + ' ' + o.py + ')';
          o.g.setAttribute('transform', tr); if (o.gb) o.gb.setAttribute('transform', tr);
        }
        if (orr !== o.o) { o.o = orr; o.g.style.opacity = orr; if (o.gb) o.gb.style.opacity = orr; }
      }
      var k = Math.min(N - 1, Math.max(0, Math.floor(b + 0.25)));
      if (k !== on) {
        if (labels[on]) labels[on].classList.remove('is-on');
        if (labels[k]) labels[k].classList.add('is-on');
        on = k;
      }
      root._pbdsB = b;
    }
    function kick() { if (!raf) { raf = true; requestAnimationFrame(frame); } }
    function onResize() { if (innerWidth === vw && Math.abs(innerHeight - vh) <= 150) return; measure(); kick(); }

    measure(); frame();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { near = es[0].isIntersecting; if (near) kick(); }, { rootMargin: '50% 0px 50% 0px' }).observe(track);
    } else near = true;
    addEventListener('scroll', function () { if (near) kick(); }, { passive: true });
    addEventListener('resize', onResize, { passive: true });
    addEventListener('load', function () { measure(); kick(); });
    addEventListener('pageshow', function () { measure(); kick(); });
  }

  /* reduced motion: one static card per thing, the D-ring and that thing only */
  function staticCards(root, svg, objs) {
    var wrap = root.querySelector('[data-cards]');
    if (!wrap) return;
    var L = (wrap.getAttribute('data-l') || '').split('|');
    var h = document.createElement('h2'); h.className = 'h2 pbds__heading'; h.textContent = wrap.getAttribute('data-h') || '';
    var grid = document.createElement('div'); grid.className = 'pbds__grid';
    objs.forEach(function (o, n) {
      var sv = svg.cloneNode(true);
      sv.removeAttribute('data-stage'); sv.removeAttribute('class');
      var keep = o.getAttribute('data-obj');
      [].forEach.call(sv.querySelectorAll('[data-obj],[data-objb]'), function (e) { if ((e.getAttribute('data-obj') || e.getAttribute('data-objb')) !== keep) e.remove(); });
      var fig = document.createElement('figure'); fig.className = 'pbds__card';
      fig.appendChild(sv);
      var cap = document.createElement('figcaption'); cap.textContent = L[n] || ''; fig.appendChild(cap);
      grid.appendChild(fig);
    });
    wrap.appendChild(h); wrap.appendChild(grid);
    wrap.removeAttribute('aria-hidden');
    root.classList.add('is-static');
  }

  /* part 2 (the chooser): when a tab opens, the thing on its D-ring (and in the close-up bubble) swings once and settles.
     A short time-based swing on a click, not tied to scroll; none under reduced motion. */
  function chooser(root) {
    if (root.__pbdc || RM) return;
    root.__pbdc = 1;
    var ins = [].slice.call(root.querySelectorAll('.pbdc__in'));
    function swing(n) {
      var gs = [].slice.call(root.querySelectorAll('.pbdc__panel--' + n + ' .pbv-hang'));
      if (!gs.length) return;
      var t0 = 0, D = 1700;
      function f(ts) {
        if (!t0) t0 = ts;
        var u = Math.min(1, (ts - t0) / D), a = 15 * Math.exp(-3.4 * u) * Math.cos(6.2832 * 1.7 * u) * (1 - u);
        for (var i = 0; i < gs.length; i++) {
          var g = gs[i], px = g.getAttribute('data-lpx') || g.getAttribute('data-px'), py = g.getAttribute('data-lpy') || g.getAttribute('data-py');
          g.setAttribute('transform', u < 1 ? 'rotate(' + a.toFixed(2) + ' ' + px + ' ' + py + ')' : '');
        }
        if (u < 1) requestAnimationFrame(f);
      }
      requestAnimationFrame(f);
    }
    ins.forEach(function (inp, i) { inp.addEventListener('change', function () { if (inp.checked) swing(i + 1); }); });
    var box = root.querySelector('.pbdc');
    if (box && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        var on = ins.findIndex(function (x) { return x.checked; });
        swing(on < 0 ? 1 : on + 1);
      }, { threshold: 0.35 });
      io.observe(box);
    }
  }

  function bootAll() { [].forEach.call(document.querySelectorAll('[data-pbds]'), function (r) { boot(r); chooser(r); }); }
  window.__pbdsBoot = bootAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
